<header class='ra-header'>
    <a routerLink="/home" [queryParams]="{back:1}" class="ra-logo" title='回首頁'></a>
</header>
<div class="ra-thx-wrapper">
    <div class="ra-thx-robot-wrapper">
        <div class="ra-thx-box robot-wrapper">
            <div class="ra-thx-robot-wrapper-relative">
                <div class="ra-thx-robot-text animated duration1s fadeInUp" style="animation-delay:1.0s;">
                    <p *ngIf="thx_type=='submit'">您的填答已成功送出，<br>安聯人壽會指派服務人員與<br>您聯繫，感謝您。</p>
                    <p *ngIf="thx_type=='delete'">感謝您，希望安聯人壽<br>再次為您服務。</p>
                </div>
                <div class="ra-thx-robot-graph animated duration1s fadeInDown" style="animation-delay:0.5s;"><img class="ra-thx-robot-graph" src='assets/img/thx_robot.svg' alt="機器人"></div>
                <div class="ra-thx-robot-bg animated duration1s fadeIn" style="animation-delay:0s;"><img class=" fluid" src='assets/img/thx_bg.svg' alt="背景"></div>
            </div>
        </div>
        <div class="ra-thx-box share-wrapper">
            <div class="ra-thx-pinktitle txt-idx-pinktitle animated duration1s flipInX" style="animation-delay:2.0s;">若您喜歡此智慧退休規劃工具，<br>歡迎分享給更多朋友。</div>
            <div class='ra-social ' >
                <a href="javascript:;" appSocialShare="fb"
                   class='ra-social-fb animated duration1s flipInX' style="animation-delay:2.5s;" title='問卷分享至Facebook'></a>
                <a href="javascript:;" appSocialShare="line"
                   class='ra-social-line animated duration1s flipInX' style="animation-delay:3.0s;" title='問卷分享至LINE'></a>
            </div>
        </div>
    </div>
    <div class="ra-thx-banner-wrapper">
        <p class="ra-banner-title">您可能也會感興趣</p>
        <div class="ra-carousell">
            <div class="ra-swiper-relative">
                <swiper class='swiper-container ra-thx-swiper-container'
                        id='idSwiperBanner' [config]="swiperOptions">
                    <div class='swiper-wrapper '>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://www.allianz.com.tw/zh_TW/news-and-annoucement/allianz-annoucement1.html#WeCare' target='_blank' class="ra-banner-photo" title='新冠肺炎的關懷慰問金'>
                                <img class='fluid' src="dataimg/banner01.jpg" alt="banner01"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://tsc.allianz.com.tw/crazymarket/index.html' target='_blank' class="ra-banner-photo" title='保友狂歡節'><img class='fluid' src="dataimg/banner02.jpg" alt="banner02"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://youtu.be/9K1JxMrfk78' target='_blank' class="ra-banner-photo" title='安聯退休需求解決方案'><img class='fluid' src="dataimg/banner03.jpg" alt="banner03"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://youtu.be/f1HHuHhGSrk' target='_blank' class="ra-banner-photo" title='安聯挺 你的勇敢'><img class='fluid' src="dataimg/banner04.jpg" alt="banner04"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://youtu.be/7G2u4F-MiCM' target='_blank' class="ra-banner-photo" title='Allie艾莉 安聯智能客服全新上線'><img class='fluid' src="dataimg/banner05.jpg" alt="banner05"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://product.allianz.com.tw/investment/VAW/product-description' target='_blank' class="ra-banner-photo" title='安聯人壽安易富變額年金保險(VAW)'><img class='fluid' src="dataimg/banner06.jpg" alt="banner01"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://youtu.be/McFG0_sbgik' target='_blank' class="ra-banner-photo" title='全新安聯e網通 看它 大顯神通'><img class='fluid' src="dataimg/banner07.jpg" alt="banner02"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://www.youtube.com/watch?v=MzW5-WJ0n8k&t=70s' target='_blank' class="ra-banner-photo" title='安聯人壽公司簡介影片'><img class='fluid' src="dataimg/banner08.jpg" alt="banner03"></a>
                        </div>
                        <div class='swiper-slide ra-thx-swiper-slide'>
                            <a href='https://youtu.be/fckel7gFztY' target='_blank' class="ra-banner-photo" title='2020保戶APP 安聯e服務'><img class='fluid' src="dataimg/banner09.jpg" alt="banner04"></a>
                        </div>
                    </div>
                </swiper>
                <div class="ra-swiper-ctrl">
                    <div class="swiper-pagination ra-thx-swiper-pagination"></div>
                    <div class='swiper-button-prev ra-thx-swiper-button-prev'><span class="ndbx-icon ra-icon-48 ra-icon--arrow-left-slim"></span></div>
                    <div class='swiper-button-next ra-thx-swiper-button-next'><span class="ndbx-icon ra-icon-48 ra-icon--arrow-right-slim"></span></div>
                </div>
            </div>
        </div>
        <a href="https://www.allianz.com.tw/zh_TW.html" class="ra-btn ra-idx-btn ra-btn-txt-arrow-tail ra-btn-dark" style='width: 240px;'><span class='txt-idx-btn-txt'>關閉安聯智慧退休小幫手</span></a>
    </div>
</div>
<footer class='ra-footer ra-footer-thx'>
    <div class="ra-ft-in">
        <div class="ra-ft-copyright txt-ft-cp">©Allianz 2021. All Rights Reserved.</div>
        <div class="ra-ft-link">
            <a href="https://www.allianz.com.tw/zh_TW/statement.html" class='txt-ft-a ra-ft-announce' title='網站聲明' target="_blank">網站聲明</a>
            <!-- <a href="javascript:;" class='txt-ft-a ra-ft-cookies' title='Cookies政策' data-open="idModalCookies">Cookies政策</a> -->
            <a href="https://www.allianz.com.tw/zh_TW/about-us/contact-us/contact-us.html" class='txt-ft-a ra-ft-contact' title='聯絡我們' target="_blank">聯絡我們</a>
        </div>
    </div>
</footer>
